// extracted by mini-css-extract-plugin
module.exports = {"leadership__hero":"FranchiseLeaderOrVideoListing_leadership__hero__AXlpQ","leaders__listing":"FranchiseLeaderOrVideoListing_leaders__listing__O7PvS"};